const { isArray } = require('../is-array')
const { isString } = require('../is-string')
const { size } = require('../size')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * Gets error name
 * @param {array|object|undefined} errors
 * @returns {Object}
 */
function getErrorName (errors) {
  let error

  if (isArray(errors) && size(errors)) {
    error = errors?.[0]?.name
  } else if (isString(errors) && size(errors)) {
    error = errors
  } else {
    error = null
  }

  return error
}

module.exports = { getErrorName }
